import SkeletonItem from '@/features/pos/components/ProductCatalog/parts/CategoryBar/parts/Skeleton/parts/SkeletonItem'
import { FC } from 'react'

const Skeleton: FC = () => {
    return (
        <>
            {Array.from({ length: 8 }, (_, index) => (
                <SkeletonItem key={index} />
            ))}
        </>
    )
}

export default Skeleton
